/**
 * @author 冷 (https://github.com/LengYXin)
 * @email [lengyingxin8966@gmail.com]
 * @create date 2020-07-29 22:38:49
 * @modify date 2020-07-29 22:38:49
 * @desc [正则列表]
 */
export class CustomRegulars {
  /******************************************【              文字字符相关              】******************************************/
  /******************************************【              文字字符相关              】******************************************/
  /******************************************【              文字字符相关              】******************************************/

  /**
   * 密码强度校验， 必须为8-20位  可以设置大写字母、小写字母、数字和部分特殊字符 必须同时包含三种组合及以上
   * @examples  ['123456Zy']
   */
  static readonly passwordRule =
    /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/;

  /**
   * 手机号脱敏
   * @examples  ['165****3333']
   */
  static readonly phoneInsensitive = /(\d{3})\d*(\d{4})/;

  /**
   * 账号脱敏
   * @examples  ['165****3333']
   */
  static readonly accountInsensitive = /(\d{1})\d*(\d{2})/;

  /**
   * 短信验证码，6位纯数字
   * @examples  ['123456']
   */
  static readonly verificationCode = /^\d{6}$/;

  /**
   * 姓名限制
   * @examples 2～50 不能是纯数字或纯符号
   */
  static readonly name_restriction_mixture =
    /^(?!\d+$)(?![`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]+$)\S{2,50}$/;
}
